import { useState } from 'react';
import { Link } from 'react-router-dom';

interface ProductCardProps {
  id: string;
  name: string;
  price: number;
  originalPrice: number;
  unit: string;
  image: string;
  sales: number;
  rating: number;
  origin: string;
}

export default function ProductCard({ id, name, price, originalPrice, unit, image, sales, rating, origin }: ProductCardProps) {
  const [imgError, setImgError] = useState(false);

  return (
    <Link
      to={`/categories`}
      className="group block bg-background-50 rounded-lg border border-background-200 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
      data-product-shop
    >
      <div className="relative w-full aspect-square overflow-hidden bg-background-100">
        {!imgError ? (
          <img
            src={image}
            alt={name}
            title={`${name} - 优质水蜜桃产地直发`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <div className="w-16 h-16 flex items-center justify-center">
              <i className="ri-leaf-line text-4xl text-primary-300"></i>
            </div>
          </div>
        )}
        <div className="absolute top-3 left-3">
          <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
            热销
          </span>
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-1 mb-1.5">
          <span className="text-xs text-foreground-500">{origin}</span>
        </div>
        <h3 className="text-sm font-medium text-foreground-900 mb-2 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {name}
        </h3>
        <div className="flex items-center gap-2 mb-2">
          <span className="text-lg font-semibold text-primary-600">
            ¥{price}
          </span>
          <span className="text-xs text-foreground-400 line-through">
            ¥{originalPrice}
          </span>
          <span className="text-xs text-foreground-400">/{unit}</span>
        </div>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </div>
            <span>{rating}</span>
          </div>
          <span>已售 {sales >= 1000 ? `${(sales / 1000).toFixed(1)}k` : sales}</span>
        </div>
      </div>
    </Link>
  );
}